export function formatINR(amount) {
  const num = Number(amount || 0);
  return "\u20B9 " + num.toLocaleString("en-IN", { maximumFractionDigits: 0 });
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}

export function statusTone(status) {
  const s = (status || "").toLowerCase();
  if (["paid", "completed", "active", "approved"].includes(s)) return "bg-[#00E054] text-black";
  if (["pending", "in progress", "assigned", "reviewed", "invited"].includes(s)) return "bg-[#FFEA00] text-black";
  if (["rejected", "cancelled", "overdue", "deactivated"].includes(s)) return "bg-[#FF2A00] text-white";
  if (["new", "planned"].includes(s)) return "bg-[#D4FF00] text-black";
  return "bg-neutral-200 text-black";
}
